import { decodeLocationQS, decodeQS } from "../../../../lib/utils/QueryStringUtils.js";
import { VideoInfoRawData } from "../../../../model/video/VideoInfo.js";
import { AdUnit } from "../../AdUnit.js";
import { AdCallParams } from "../../AdCallParams.js";
import { HasAdCallParamsFilter } from "../ComposableResolver.js";





export class UTMAdCallFilter implements HasAdCallParamsFilter {




    constructor(private window: Window) {

    }
    
    filterAdCall(unit: AdUnit, info: VideoInfoRawData, params: AdCallParams): AdCallParams {

        const useParams: AdCallParams = params?params:{};
        useParams.custom_params = useParams.custom_params?useParams.custom_params:{};

        const qs = decodeLocationQS(this.window.location,true);

        const utm_medium = "utm_medium" in qs?qs.utm_medium:null;
        const utm_source = "utm_source" in qs?qs.utm_source:null;
        const utm_campaign = "utm_campaign" in qs?qs.utm_campaign:null;

        if(utm_medium) {
            useParams.custom_params.utm_medium = utm_medium;
            const url = useParams.custom_params.url?useParams.custom_params.url:"";
            useParams.custom_params.url = utm_medium +"_" + url;
        }
        if(utm_source) useParams.custom_params.utm_source = utm_source;
        if(utm_campaign) useParams.custom_params.utm_campaign = utm_campaign;
        

        return useParams;
    }


}